import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home1 from "./pages";
import Aktoprak from "./pages/projects/aktoprak";
import Yamactepe from "./pages/projects/yamactepe";
import Portfolio from "./pages/innerpages/portfolio";
import Blog from "./pages/innerpages/blog";
import Contact from "./pages/innerpages/contact";
import SinglePost from "./pages/innerpages/single_post";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home1 />} />
        <Route path="/projects/aktoprak" element={<Aktoprak/>} />
        <Route path="/projects/yamactepe" element={<Yamactepe/>} />
        <Route path="/portfolio" element={<Portfolio/>} />
        <Route path="/blog" element={<Blog/>} />
        <Route path="/blog/:slug" element={<SinglePost/>} />
        <Route path="/contact" element={<Contact/>} />
      </Routes>
    </Router>
  );
}

export default App;
